/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React, { useState } from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { BasicAlert } from '../alert/BasicAlert';
import { FieldProps, FormGenerator } from '../form/FormGenerator';
import { SubmitButton } from '../button/SubmitButton';
import './user-interest-modal.scss';
import G17Client from '../../services/G17Client';

interface RequestDemoModalProps {
  toggle: () => void;
  isOpen: boolean;
  title: string;
  onSubmit?: () => unknown;
}

interface FormState {
  title: string,
  message: string
}


const fields: FieldProps[] = [
  {
    code: 'message',
    type: 'textarea',
    required: true,
    label: 'Message',
    htmlLabel: <h5 className='mt-2 d-inline'>Message</h5>,
  },
]

export const UserInterestModal = (props: RequestDemoModalProps) => {

  const { toggle, isOpen, title, onSubmit } = props;
  const [msg, setMsg] = useState({ successMessage: '', errorMessage: '' });
  const [formData, setFormData] = useState<FormState>({ title, message: '' });


  const onModalSubmit = async () => {
    G17Client.userInterest(formData).then(() => {
      setMsg((msg) => ({ ...msg, successMessage: 'Message sent. We’ll be in touch shortly.' }));
      setTimeout(async () => {
        toggle();
        if (onSubmit) {
          await onSubmit()
        }
      }, 2000);
    }).catch((e) => {
      setMsg((msg) => ({ ...msg, errorMessage: e.message }));
    });
  };

  const isFormValid = formData.title && formData.message;

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop='static' className='request-demo-modal'>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <BasicAlert type={'success'}>{msg.successMessage}</BasicAlert>

        <div className={'user-interest-form'}>
          <BasicAlert type={'danger'}>{msg.errorMessage}</BasicAlert>

          <FormGenerator
            fields={fields}
            form={formData}
            updateForm={(e) => setFormData((f) => ({ ...f, [e.target.name]: e.target.value }))}/>

          <div className={'text-right'}>
            <SubmitButton className='px-5' disabled={!isFormValid} color='primary' onClick={onModalSubmit}>
              Submit
            </SubmitButton>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

